module.exports = __webpack_public_path__ + "static/media/LoginPageLayer.d0507053.png";